// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { jettingAppGraphStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppGraph";
import IconTooltip from "@stoneage/XDL/Icons/IconTooltip";
import { color, xScreen } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

jettingAppGraphStyles.legendsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        margin-top: 16px;
        ${xScreen("lte", "md")} {
            margin-top: 0;
            width: calc(50% - 16px);
        }
        ${xScreen("lte", 767)} {
            margin-top: 16px;
            width: 100%;
        }
    `,
};
jettingAppGraphStyles.canvasWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            width: calc(50% - 16px);
            canvas {
                width: 100%;
                height: auto;
            }
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            canvas {
                width: 100%;
                height: auto;
            }
        }
    `,
};
jettingAppGraphStyles.legendWrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

jettingAppGraphStyles.legendLabel = {
    size: 12,
    lineHeight: "18px",
};

jettingAppGraphStyles.legendIcon = {
    css: css`
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: ${color("common.border")};
        ${({ background }: any) =>
            background &&
            css`
                background: ${background};
            `}
    `,
};
jettingAppGraphStyles.tooltip = {
    iconProps: {
        src: IconTooltip,
        color: "primary.main",
        size: 14,
        css: css`
            margin-left: 4px;
            &: hover {
                opacity: 0.33;
            }
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            &[aria-expanded="true"] {
                ${IconWrapper} {
                    color: ${color("common.black")};
                }
            }
        `,
    },
};
jettingAppGraphStyles.chartTitle = {
    size: 15,
    lineHeight: "26px",
    weight: "bold",
    css: css`
        display: flex;
        margin-bottom: 8px;
        align-items: baseline;
        ${xScreen("lte", 767)} {
            margin-top: 28px;
        }
    `,
};

jettingAppGraphStyles.graphWrapper = {
    css: css`
        ${xScreen("lte", "md")} {
            display: flex;
            column-gap: 16px;
        }
        ${xScreen("lte", 767)} {
            display: block;
        }
    `,
};
